// extracted by mini-css-extract-plugin
export default {"head":"goBack_head__7XRtl","arrow":"goBack_arrow__lhuN2","back":"goBack_back__Epdd1"};